import { CustomerDetails } from '@/types/customers';
import { SVSummaryCard } from '../core';
import { formatCurrency } from '@/utils/currency';

type CustomerDepositRulesProps = {
  customerDetails: CustomerDetails;
};

export default function CustomerDepositRules({
  customerDetails,
}: CustomerDepositRulesProps) {
  const { minimumInitDeposit, maximumInitDeposit } = customerDetails;
  if (!minimumInitDeposit && !maximumInitDeposit) {
    return null;
  }

  return (
    <SVSummaryCard
      label="Deposit Rules"
      items={[
        {
          label: 'Initial Deposit Minimum',
          text: formatCurrency({ amount: minimumInitDeposit?.value || '' }),
        },
        {
          label: 'Initial Deposit Maximum',
          text: formatCurrency({ amount: maximumInitDeposit?.value || '' }),
        },
      ]}
    />
  );
}
